import axios from 'axios'

export const state = {
  cachedConfigurations: null,
  selectedConfiguration: null,
}

export const getters = {
  cachedConfigurations(state) {
    return state.cachedConfigurations
  },
}

export const mutations = {
  SET_CACHE(state, configurations) {
    state.cachedConfigurations = configurations
  },
}

export const actions = {
  fetchConfigurations({ commit, state, rootState }, { clearCache }) {
    // 1. Check if we've already fetched and cachedConfigurations the user.
    const cachedConfigurations = state.cachedConfigurations
    if (!clearCache && cachedConfigurations) {
      return Promise.resolve(cachedConfigurations)
    }

    // 2. Fetch the configurations from the API and cache it in case
    // we need it again in the future.
    return axios
      .get('/api/services/app/configuration/GetAll')
      .then((response) => {
        const configurations = response.data.items

        commit('SET_CACHE', configurations)

        return configurations
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },

  updateConfiguration({ commit, dispatch, state, rootState }, { configuration }) {
    return axios
      .put('/api/services/app/configuration/Update', configuration)
      .then((response) => {
        dispatch('fetchConfigurations', { clearCache: true })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },

  deleteConfiguration({ commit, dispatch, state, rootState }, { id }) {
    return axios
      .delete('/api/services/app/configuration/Delete/?id=' + id + '&userId=' + '1')
      .then((response) => {
        dispatch('fetchConfigurations', { clearCache: true })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },
}
